import axios from 'axios';
import { auth } from '../../../firebase';
import { UserPreference } from '../../Interfaces/admin/User.interfaces';

const apiUrl = process.env['NX_API_URL'];

export const getUserPreference = async (
  name: string,
  section: string
): Promise<UserPreference> => {
  const response = await axios.get(`${apiUrl}/api/user/preferences`, {
    params: { name, section },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });

  return response.data;
};

export const postUserPreference = async (
  name: string,
  section: string,
  preference: unknown
): Promise<string> => {
  const response = await axios.post(
    `${apiUrl}/api/user/preferences`,
    { name, section, preference },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
      },
    }
  );

  return response.data;
};

export const putUserPreference = async (id: string, preference: unknown) => {
  const response = await axios.put(
    `${apiUrl}/api/user/preferences/${id}`,
    { preference },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
      },
    }
  );

  return response.data;
};

export const postUserRequest = async (content: string) => {
  const response = await axios.post(
    `${apiUrl}/api/requests`,
    { content },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
      },
    }
  );

  return response.data;
};
